import enUS from 'date-fns/locale/en-US';
import ptBR from 'date-fns/locale/pt-BR';
import esES from 'date-fns/locale/es';
import itIT from 'date-fns/locale/it';
import i18next from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';
import { registerLocale } from 'react-datepicker';
import { initReactI18next, useTranslation } from 'react-i18next';
import env from '../.env.js';

i18next
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    initImmediate: false,
    fallbackLng: 'en',
    lng: 'pt-BR',
    debug: env.I18N_LOG,
    interpolation: {
      escapeValue: false,
    },
  });

registerLocale('pt-BR', ptBR);
registerLocale('en-US', enUS);
registerLocale('es-ES', esES);
registerLocale('it-IT', itIT);

export const useLanguage = () => i18next.language;
export const useI18N = () => useTranslation().t as (nome: string, values?: any) => string;
export const currentLocale = () => i18next.language;
export const changeLanguage = i18next.changeLanguage;
